import { ACTIVITY_PATHS } from '@cast/console-constants';
import { makeSearchQuery } from '@cast/shared-search-ui';

type OrgAuditLogLinkArgs = {
  clusterId: string;
  fromDate?: string;
  toDate?: string;
  timezone: string;
  freeText?: string;
};

export const makeOrgAuditLogLink = ({
  clusterId,
  fromDate,
  toDate,
  timezone,
  freeText,
}: OrgAuditLogLinkArgs) => {
  const searchParams = makeSearchQuery({
    id: 'audit',
    values: {
      clusterIdFilter: [clusterId],
      ...(fromDate && toDate && { dateRange: { fromDate, toDate, timezone } }),
    },
    ...(freeText && { freeText }),
  });
  return `${ACTIVITY_PATHS.activityEvents}?${searchParams}`;
};
